import { render, staticRenderFns } from "./SingleItemSelector.vue?vue&type=template&id=0b5443e7"
import script from "./SingleItemSelector.vue?vue&type=script&lang=js"
export * from "./SingleItemSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports